import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { CarouselSlide } from '../carousel-slide/carousel';
import { CarouselSlideItem } from '../carousel-slide/carousel-slide-item/carousel-slide';
@Component({
  standalone: false,
  selector: 'app-carousel-view',
  templateUrl: './carousel-view.component.html'
})
export class CarouselViewComponent implements OnInit, OnChanges {
  @Input() imageList: any[];
  @Input() carouselSlide: CarouselSlide;
  @Input() carouselSlideItem: CarouselSlideItem;
  @Input() containerHeight: string;
  @Input() currentSlide = '';
  @Input() enableDownload = false;

  public carouselSlideConfig: CarouselSlide;
  public carouselSlideItemConfig: CarouselSlideItem;
  public parentHeight: string;
  public imageSlice: any[];

  constructor() {}
  ngOnInit() {}
  ngOnChanges() {
    this.imageSlice = this.imageList;
    this.parentHeight = this.containerHeight;

    // Set currentSlide only if it is not already assigned and there are images
    if (!this.currentSlide && this.imageList && this.imageList.length > 0) {
      this.currentSlide = this.imageList[0];
    }

    this.carouselSlideConfig = {
      timings: this.carouselSlide ? this.carouselSlide['timings'] : '250ms ease-in',
      autoplay: this.carouselSlide ? this.carouselSlide['autoplay'] : true,
      interval: this.carouselSlide ? this.carouselSlide['interval'] : 5000,
      loop: this.carouselSlide ? this.carouselSlide['loop'] : false,
      hideArrows: this.carouselSlide ? this.carouselSlide['hideArrows'] : true,
      hideIndicators: this.carouselSlide ? this.carouselSlide['hideIndicators'] : true,
      color: this.carouselSlide ? this.carouselSlide['color'] : 'accent',
      maxWidth: this.carouselSlide ? this.carouselSlide['maxWidth'] : 'auto',
      proportion: this.carouselSlide ? this.carouselSlide['proportion'] : 100,
      slides: this.carouselSlide ? this.carouselSlide['slides'] : 1,
      maintainAspectRatio: this.carouselSlide ? this.carouselSlide['maintainAspectRatio'] : false,
      slideHeight: this.carouselSlide ? this.carouselSlide['slideHeight'] : '0px',
      useKeyboard: this.carouselSlide ? this.carouselSlide['useKeyboard'] : true,
      useMouseWheel: this.carouselSlide ? this.carouselSlide['useMouseWheel'] : false,
      orientation: this.carouselSlide ? this.carouselSlide['orientation'] : 'ltr',
      svgIconOverrides: this.carouselSlide ? this.carouselSlide['svgIconOverrides'] : null
    }
    this.carouselSlideItemConfig = {
      overlayColor: this.carouselSlideItem ? this.carouselSlideItem['overlayColor'] : '',
      hideOverlay: this.carouselSlideItem ? this.carouselSlideItem['hideOverlay'] : false,
      imageSize: this.carouselSlideItem ? this.carouselSlideItem['imageSize'] : 'cover',
      disabled: this.carouselSlideItem ? this.carouselSlideItem['disabled'] : false
    }
  }

  onSlideChange(index: number) {
    this.currentSlide = this.imageList[index];
  }

  // IMPORTANT: Triggering a download with a programmatically created <a> element
  // may cause the browser (Chrome/Edge) to disconnect the hot reload WebSocket in this tab.
  // After a download, Angular's hot reload will NOT update the UI automatically in this tab.
  // This is browser behavior, not an Angular bug. Other tabs remain unaffected.
  // For development, use a separate tab for downloads if you need hot reload.
  // If this tab stops updating, manually refresh with Ctrl+Shift+F5 to restore hot reload.
  downloadImage(imageUrl: string): void {
    if (!imageUrl) {
      console.warn('No hay imagen para descargar');
      return;
    }
    setTimeout(() => {
      const link = document.createElement('a');
      link.href = imageUrl;
      link.setAttribute('download', '');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, 0);
  }

}
